module.exports = __webpack_public_path__ + "img/calif_es.41a1e8ce.webp";